import {
	officeWordEditURL,
	officeWordViewURL,
	officeExcelEditUrl,
	officeExcelViewUrl,
	officePresentationEditUrl,
	officePresentationViewUrl,
	wopitestEditURL,
	wopitestViewURL,
	wopitestxViewURL,
	wopitestxEditURL,
} from '../../src/config/app.config.js';

const endpoints = {
	docx: {
		view: officeWordViewURL,
		edit: officeWordEditURL,
	},
	pptx: {
		view: officePresentationViewUrl,
		edit: officePresentationEditUrl,
	},
	xlsx: {
		view: officeExcelViewUrl,
		edit: officeExcelEditUrl,
	},
	wopitest: {
		view: wopitestViewURL,
		edit: wopitestEditURL,
	},
	wopitestx: {
		view: wopitestxViewURL,
		edit: wopitestxEditURL,
	},
};

export const getOfficeEndpoint = (extension, action) => {
	return endpoints?.[extension]?.[action];
};
